import { createSelector, gettr } from './utils';

export const getLogs = createSelector([gettr('log')], (f => f?.items ?? {}));
